"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isActionList = exports.isAction = void 0;
const filter_1 = require("@dqm/filter");
function isAction(value) {
    if (typeof value.key !== "string") {
        return false;
    }
    if (typeof value.text !== "string") {
        return false;
    }
    if (typeof value.payload !== "object") {
        return false;
    }
    if ("active" in value) {
        if (!(typeof value.active === "boolean" || (0, filter_1.isExpression)(value.active))) {
            return false;
        }
    }
    return true;
}
exports.isAction = isAction;
function isActionList(value) {
    if (!Array.isArray(value)) {
        return false;
    }
    for (const action of value) {
        if (!isAction(action)) {
            return false;
        }
    }
    return true;
}
exports.isActionList = isActionList;
//# sourceMappingURL=Action.js.map